import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { ActiveErrorLens, CancelErrorLens, ClearErrorLens, CreateErrorLens, RefreshErrorLens } from '@infl-ts/util-lens';
import { Typography, useTheme } from '@mui/material';
import { absurd, constant, pipe, tuple } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { ActionLink, NotificationWrapper } from './success-notification';
import { useRetry } from './use-retry';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var contactSupport = function contactSupport() {
  window.open('https://influitive-supportdesk.zendesk.com/hc', '_blank');
  location.reload();
};

var getErrorAction = function getErrorAction(lens, _ref) {
  var loadLens = _ref.loadLens,
      cancelLens = _ref.cancelLens,
      clearLens = _ref.clearLens,
      refreshLens = _ref.refreshLens,
      activateLens = _ref.activateLens;
  return CreateErrorLens.is(lens) ? ['loading', loadLens] : CancelErrorLens.is(lens) ? ['cancelling', cancelLens] : ClearErrorLens.is(lens) ? ['clearing', clearLens] : RefreshErrorLens.is(lens) ? ['refreshing', refreshLens] : ActiveErrorLens.is(lens) ? ['viewing', activateLens] : absurd(lens);
};

var ErrorNotification = function ErrorNotification(_ref2) {
  var lens = _ref2.lens,
      actions = _ref2.actions;
  var theme = useTheme();

  var _getErrorAction = getErrorAction(lens, actions),
      _getErrorAction2 = _slicedToArray(_getErrorAction, 2),
      text = _getErrorAction2[0],
      action = _getErrorAction2[1];

  var _pipe = pipe(useRetry(3, action), O.match(constant(tuple('Contact Support and Reload', contactSupport)), function (onClick) {
    return tuple('Retry', onClick);
  })),
      _pipe2 = _slicedToArray(_pipe, 2),
      label = _pipe2[0],
      onClick = _pipe2[1];

  return /*#__PURE__*/_jsxs(NotificationWrapper, {
    barColor: theme.palette.error.dark,
    "data-element": "NotificationWrapper",
    "data-component": "ErrorNotification",
    "data-source-file": "error-notification.tsx",
    children: [/*#__PURE__*/_jsxs(Typography, {
      variant: "body2",
      "data-element": "Typography",
      "data-component": "ErrorNotification",
      "data-source-file": "error-notification.tsx",
      children: ["An error occured while ", text, " your Lens."]
    }), /*#__PURE__*/_jsx(ActionLink, {
      onClick: onClick,
      "data-element": "ActionLink",
      "data-source-file": "error-notification.tsx",
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "body2",
        "data-element": "Typography",
        "data-source-file": "error-notification.tsx",
        children: label
      })
    })]
  });
};

export default ErrorNotification;